import type { ReactNode } from 'react'
import type { AsyncState } from '../lib/useAsync'
import { ErrorCard } from './ErrorCard'

/**
 * Render a loading skeleton, an ErrorCard, an empty-state, or the children —
 * the standard four-way branch every portal page needs.
 */
export function AsyncBlock<T>({
  state,
  isEmpty,
  emptyText,
  children,
}: {
  state: AsyncState<T>
  isEmpty?: (data: T) => boolean
  emptyText?: string
  children: (data: T) => ReactNode
}): JSX.Element {
  if (state.loading) {
    return (
      <div className="skeleton-group" aria-busy="true" aria-label="Loading">
        <div className="skeleton-row" />
        <div className="skeleton-row" />
        <div className="skeleton-row" />
      </div>
    )
  }
  if (state.error || !state.data) {
    return <ErrorCard error={state.error} onRetry={state.reload} />
  }
  if (isEmpty && isEmpty(state.data)) {
    return (
      <div className="card empty-card">
        <p>{emptyText ?? 'Nothing here yet.'}</p>
      </div>
    )
  }
  return <>{children(state.data)}</>
}
